import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  Button,
  CircularProgress,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PeopleIcon from "@mui/icons-material/People";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { fetchFriendProfile } from "../../apiservices/ApiService";

const ProfileCard = () => {
  const [profileData, setProfileData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadProfileData = async () => {
    setIsLoading(true);
    try {
      const data = await fetchFriendProfile({ friendId: "114495" });
      setProfileData(data);
    } catch (err) {
      console.error("Error fetching profile data:", err);
      setError("Failed to load profile data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadProfileData();
  }, []);

  // Loading State
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={60} />
      </Box>
    );
  }

  // Error State
  if (error) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Box>
    );
  }

  if (!profileData) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography variant="h6">No profile data available.</Typography>
      </Box>
    );
  }

  const {
    userImage,
    userCoverImage,
    fullName,
    userBio,
    joinedSince,
    stepCovered,
    friendCount,
    followCount,
    followTitle,
    karmaDonated,
    profileBadge,
    profileRingColor,
  } = profileData;

  return (
    <Card
      sx={{
        width: "100%",
        mx: "auto",
        mt: 0,
        borderRadius: 0,
        boxShadow: 6,
        overflow: "hidden",
        backgroundColor: "#fdfdfd",
      }}
    >
      {/* Cover Image */}
      <Box
        sx={{
          height: 140,
          backgroundImage: `url(${userCoverImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Avatar */}
        <Avatar
          src={userImage}
          alt={fullName}
          sx={{
            width: 100,
            height: 100,
            position: "absolute",
            bottom: -50,
            left: "50%",
            transform: "translateX(-50%)",
            border: "5px solid #fff",
            boxShadow: 2,
            backgroundColor: profileRingColor,
          }}
        />
      </Box>

      {/* Content */}
      <CardContent sx={{ pt: 6, textAlign: "center" }}>
        {/* Name and Bio */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {fullName} 👤
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {userBio} ✨
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {joinedSince} 🗓️
        </Typography>

        {/* Stats */}
        <Box display="flex" justifyContent="space-around" mb={2}>
          <Box textAlign="center">
            <DirectionsWalkIcon fontSize="large" color="primary" />
            <Typography variant="h6" fontWeight="bold">
              {stepCovered}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Steps 🚶
            </Typography>
          </Box>
          <Box textAlign="center">
            <PeopleIcon fontSize="large" color="success" />
            <Typography variant="h6" fontWeight="bold">
              {friendCount}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Friends 👥
            </Typography>
          </Box>
          <Box textAlign="center">
            <FavoriteIcon fontSize="large" color="error" />
            <Typography variant="h6" fontWeight="bold">
              {followCount}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Follow ❤️
            </Typography>
          </Box>
        </Box>

        {/* Karma and Badge */}
        <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
          <EmojiEventsIcon fontSize="large" color="warning" />
          <Typography variant="body2" color="text.secondary" ml={1}>
            Karma Donated: <b>{karmaDonated} 🎖️</b>
          </Typography>
        </Box>

       
      </CardContent>
    </Card>
  );
};

export default ProfileCard;